<template>
    <div class="karanteeni-discord">
        <h1>Karanteeni Discord</h1>
        <h2>Lista komennoista</h2>
        <div class="commands">
            <div v-for="command in commands" :key="command.name" class="command">
                <h4>/{{ command.name }}</h4>
                <p class="command-desc">{{ command.desc }}</p>
                <p v-if="command.admin">Admin komento</p>
                <p v-if="!command.requireGuild">Voi lähettää yksityisviestinä</p>
                <p>
                    Syntaksi: <code>/{{ command.syntax }}</code>
                </p>
                <p>
                    Triggerit:
                    <code>
                        <span v-for="trigger in command.triggers" :key="trigger">/{{ trigger }}{{ ' ' }}</span>
                    </code>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import commands from '../commandMetaMap.json'

export default {
    name: 'karanteeni-discod-bot',
    data: () => {
        return {
            commands
        }
    },
    metaInfo: {
        title: 'Karanteeni Discord Bot'
    }
}
</script>

<style scoped>
code {
    background: var(--code-bg);
    padding: 0.2em 0.5em;
    color: var(--code-1);
    display: inline-flex;
    justify-content: center;
    align-items: center;
}
.commands {
    display: grid;
    grid-template-columns: repeat(auto-fill, 500px);
    gap: 1em;
}

.command {
    background: var(--card-bg);
    padding: 0.7em;
    border-radius: 6px;
    font-size: 0.9em;
}

.command-desc {
    color: var(--font-3);
    font-style: italic;
    margin-bottom: 0.3em;
    margin-top: 0;
}

.command h4 {
    margin-top: 0;
    margin-bottom: 0.3em;
}

.features > li {
    font-weight: 600;
}

.features > li > ul {
    font-weight: 400;
}

.features ul {
    padding-left: 2em;
    line-height: 1.5;
}

.features li {
    margin-bottom: 0.3em;
}

.features li:last-child {
    margin-bottom: 1em;
}

.features li:first-child {
    margin-top: 0.5em;
}

figure {
    margin: 0.5em;
    background: var(--bg-3);
    padding: 0.5em 1em;
    text-align: center;
    font-style: italic;
    color: var(--font-1);
    font-size: 0.9em;
}

img {
    width: 100%;
    max-width: 520px;
    display: block;
    margin-bottom: 2.2em;
    margin-top: 0.8em;
}
</style>
